/**
 * Highcharts tooltip show delay plugin.
 *
 * Adds a `tooltip.delayForDisplay` option (in milliseconds) that delays
 * the tooltip from appearing when hovering over chart points.
 *
 * Based on https://github.com/rudovjan/highcharts-tooltip-delay (MIT).
 *
 * Usage:
 *   import("highcharts").then((Highcharts) => {
 *     patchTooltipDelay(Highcharts.default)
 *     Highcharts.default.chart(el, { tooltip: { delayForDisplay: 300 } })
 *   })
 */

let patched = false

export function patchTooltipDelay(H) {
  if (patched) return
  patched = true

  const timers = {}

  const pointKey = (pt) => `${pt.category} ${pt.series.name}: ${pt.x} ${pt.y}`

  const pointsKey = (points) =>
    Array.isArray(points) ? points.map(pointKey).join(", ") : pointKey(points)

  H.wrap(H.Tooltip.prototype, "refresh", function (proceed) {
    const args = Array.prototype.slice.call(arguments, 1)
    const tooltip = this
    const key = pointsKey(args[0])
    const delay = this.chart.options.tooltip.delayForDisplay ?? 0

    if (!delay) {
      return proceed.apply(tooltip, args)
    }

    clearTimeout(timers[key])

    timers[key] = setTimeout(() => {
      const pointOrPoints = args[0]
      const hoverPoint = tooltip.chart.hoverPoint

      if (
        hoverPoint === pointOrPoints ||
        (Array.isArray(pointOrPoints) && pointOrPoints.includes(hoverPoint))
      ) {
        proceed.apply(tooltip, args)
      }

      delete timers[key]
    }, delay)
  })
}
